export const inspectTable_1 = [
  {
    content: `1. 산업안전보건법 요지 게시 상태`,
    isChecked: ``,
  },
  {
    content: `2. 적정한 보호구 지급, 착용 및 관리 상태`,
    isChecked: ``,
  },
  {
    content: `3. 도로 청소 시 반사판 안전조끼 착용 상태`,
    isChecked: ``,
  },
  {
    content: `4. 야간 작업 시 헤드램프 등 조명기구 지급 관리`,
    isChecked: ``,
  },
  {
    content: `5. 안전보건표지 설치상태(금지, 경고, 지시표시 등)`,
    isChecked: ``,
  },
  {
    content: `6. 자재정리 등 작업장 정리 정돈 및 청소 상태`,
    isChecked: ``,
  },
  {
    content: `7. 작업계획서(허가제)운영 관리 상태`,
    isChecked: ``,
  },
  {
    content: `8. 위험성 평가 실시 및 현장 운영 상태`,
    isChecked: ``,
  },
  {
    content: `9. 기타 안전보건 불합리 사항 조치이행 여부`,
    isChecked: ``,
  },
];
export const inspectTable_2 = [
  {
    content: `1. 지정된 차량 운전자 운행 및 관리 상태`,
    isChecked: ``,
  },
  {
    content: `2. 차량탑승 시 좌석안전띠 착용 여부`,
    isChecked: ``,
  },
  {
    content: `3. 차량 승차석 외 탑승 금지 관리 상태`,
    isChecked: ``,
  },
  {
    content: `4. 적재물 떨어짐 방지 조치 및 관리 상태`,
    isChecked: ``,
  },
  {
    content: `5. 비상정지 버튼 작동 여부 및 관리 상태`,
    isChecked: ``,
  },
  {
    content: `6. 차량 후방, 측방 시야확보 카메라 상태`,
    isChecked: ``,
  },
  {
    content: `7. 기타 차량 방호장치 작동 여부 확인`,
    isChecked: ``,
  },
];
export const inspectTable_3 = [
  {
    content: `1. 휴대용 전기기계기구 절연 조치 확인`,
    isChecked: ``,
  },
  {
    content: `2. 가설전선 배선경로 및 피복 손상 여부`,
    isChecked: ``,
  },
  {
    content: `3. 불티비산 발생 작업 시 안전보건 조치 이행여부`,
    isChecked: ``,
  },
  {
    content: `4. 인화성 물질 적치 시 소화설비 설치 및 관리 상태`,
    isChecked: ``,
  },
];
export const inspectTable_4 = [
  {
    content: `1. 이동식 사다리 사용 시 안전 수칙 준수 확인`,
    isChecked: ``,
  },
  {
    content: `2. 일자형 사다리는 이동통로로만 사용`,
    isChecked: ``,
  },
  {
    content: `3. 근로자 이동통로 조도 및 확보 및 정리정돈`,
    isChecked: ``,
  },
  {
    content: `4. 기계기구(예초기 등) 파손 및 방호장치 상태 점검`,
    isChecked: ``,
  },
  {
    content: `5. 기계 점검·보수 시 동력 완전 차단 작업 확인`,
    isChecked: ``,
  },
  {
    content: `6. 밀폐공간 작업허가서 이행여부 확인`,
    isChecked: ``,
  },
  {
    content: `7. 밀폐공간 확인 및 무단 출입금지 조치`,
    isChecked: ``,
  },
  {
    content: `8. 회전판 등 동력부 덮개 또는 울 방호장치 상태`,
    isChecked: ``,
  },
];
export const inspectTable_5 = [
  {
    content: `1. 유해·위험물질 취급 및 보관 상태 확인`,
    isChecked: ``,
  },
  {
    content: `2. 적정 MSDS배치 및 소단위 용기 경고표지 부착여부`,
    isChecked: ``,
  },
  {
    content: `3. 유해·위험물 취급 근로자 보호구 적정 및 교육 실시`,
    isChecked: ``,
  },
  {
    content: `4. 취약근로자 등 근로자 건강상태 및 사후관리 확인`,
    isChecked: ``,
  },
  {
    content: `5. 작업 전·중·후 근골격계 질환 예방 활동`,
    isChecked: ``,
  },
  {
    content: `6. 취약시기별 작업장 및 근로자 관리기준 이행상태`,
    isChecked: ``,
  },
  {
    content: `7. 미세먼지 및 생물학적(곤충 등) 유해인자 관리`,
    isChecked: ``,
  },
];
export const inspectTable_6 = [
  {
    content: `1. 유해·위험물질 취급 및 보관 상태 확인`,
    isChecked: ``,
  },
  {
    content: `2. 적정 MSDS배치 및 소단위 용기 경고표지 부착여부`,
    isChecked: ``,
  },
  {
    content: `3. 유해·위험물 취급 근로자 보호구 적정 및 교육 실시`,
    isChecked: ``,
  },
  {
    content: `4. 취약근로자 등 근로자 건강상태 및 사후관리 확인`,
    isChecked: ``,
  },
  {
    content: `5. 작업 전·중·후 근골격계 질환 예방 활동`,
    isChecked: ``,
  },
  {
    content: `6. 취약시기별 작업장 및 근로자 관리기준 이행상태`,
    isChecked: ``,
  },
  {
    content: `7. 미세먼지 및 생물학적(곤충 등) 유해인자 관리`,
    isChecked: ``,
  },
];
